import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const STATISTIC: AppRouteRecordRaw = {
  path: '/statistic',
  name: 'statistic',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.statistic',
    icon: 'icon-user-group',
    requiresAuth: true,
    order: 8,
  },
  children: [
    {
      path: '/station',
      alias: '/statistic/station/index',
      name: '/station',
      component: () => import('@/views/statistic/station/index.vue'),
      meta: {
        locale: 'menu.statistic.station',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: '/pile-statistic',
      alias: '/statistic/pile/index',
      name: '/pile-statistic',
      component: () => import('@/views/statistic/pile/index.vue'),
      meta: {
        locale: 'menu.statistic.pile',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default STATISTIC;
